import { BTN } from '../sim/input';

// D63 — the SESSION-level kick-consume latch. The sim's edge detection (prevButtons) is PER-ENTITY,
// but a human's button hold is PER-SESSION: when the D50 pass-follow switches control to the receiver,
// the receiver's prevButtons is the BOT's last input, so a Space still held from the pass that launched
// the ball reads as a brand-new press edge on the taken-over entity — and fires instantly (directly, or
// via the D62 one-touch arming when the reception is touch-then-claim). D54 masks this in the CLIENT,
// but its hasBall signal arrives an RTT late online, so the raw held bit is already on the wire.
//
// The authoritative rule, applied where session→entity routing is known (input assembly): a kick bit
// that was HELD at the instant the session's own kick fired is CONSUMED — stripped from every
// subsequent input, on whatever entity the session drives, until physically released. A press made
// AFTER the kick (the deliberate mid-flight tap that declares a volley) is untouched.

const KICK_BITS = BTN.PASS | BTN.THROUGH | BTN.SHOOT;

export class SessionKickLatch {
  private stale = 0;

  /** Feed every tick's raw session buttons; returns them with consumed kick bits stripped. */
  apply(buttons: number): number {
    this.stale &= buttons; // a physical release un-consumes that bit
    return buttons & ~this.stale;
  }

  /** The session's controlled entity fired a kick this tick — every kick bit still held is spent. */
  onKickFired(appliedButtons: number): void {
    this.stale |= appliedButtons & KICK_BITS;
  }

  reset(): void {
    this.stale = 0;
  }
}
